import { CChartLine } from '@coreui/react-chartjs'
import {
  CCard,
  CCardBody,
  CCardHeader,
  CCol,
  CFormLabel,
  CFormSelect,
  CRow,
} from '@coreui/react-pro'
import React, { useEffect, useState } from 'react'
import Loader from 'src/components/Loader'
import PlayerService from 'src/service/PlayerService'

const PlayerChart = () => {
  const [labelNames, setLabelNames] = useState([])
  const [playerList, setPlayerList] = useState([])
  const [priceChange, setPriceChange] = useState([])
  const [data, setData] = useState([])

  const [scData, setScData] = useState([])
  const [hwData, setHwData] = useState([])
  const [awData, setAwData] = useState([])
  const [alData, setAlData] = useState([])
  const [hlData, setHlData] = useState([])
  const [sswData, setSswData] = useState([])
  const [owtData, setOwtData] = useState([])
  const [bwmData, setBwmData] = useState([])
  const [blmData, setBlmData] = useState([])
  const [sslsData, setSslsData] = useState([])

  const [loading, setLoading] = useState(true)
  useEffect(() => {
    PlayerService.getAllPlayer().then((res) => {
      setLoading(true)
      if (res.status === 200) {
        setPlayerList(res.data)
        setLoading(false)
      }
    })
  }, [])

  const handleSearchPlayer = (e) => {
    PlayerService.playerChart(e.target.value).then((res) => {
      setLoading(true)
      if (res.status === 200) {
        setData(res.data.datasets)
        setLabelNames(res.data.labels)
        setPriceChange(res.data.priceChange)
        setScData(res.data.scData)
        setHwData(res.data.hwData)
        setAwData(res.data.awData)
        setAlData(res.data.alData)
        setHlData(res.data.hlData)
        setSswData(res.data.sswData)
        setSslsData(res.data.sslsData)
        setOwtData(res.data.owtData)
        setBwmData(res.data.bwmData)
        setBlmData(res.data.blmData)
        setLoading(false)
      }
    })
  }

  const labelNamesa = Object.keys(labelNames)
  const dataValues = Object.values(data).map((value) => parseFloat(value, 10))
  const dataPriceChangeValues = Object.values(priceChange).map((value) => parseFloat(value, 10))

  const dataScValues = Object.values(scData).map((value) => parseInt(value, 10))
  const dataHwValues = Object.values(hwData).map((value) => parseInt(value, 10))
  const dataAwValues = Object.values(awData).map((value) => parseInt(value, 10))
  const dataAlValues = Object.values(alData).map((value) => parseInt(value, 10))
  const dataHlValues = Object.values(hlData).map((value) => parseInt(value, 10))
  const dataSswValues = Object.values(sswData).map((value) => parseInt(value, 10))
  const dataSslsValues = Object.values(sslsData).map((value) => parseInt(value, 10))
  const dataOwtValues = Object.values(owtData).map((value) => parseInt(value, 10))
  const dataBwmValues = Object.values(bwmData).map((value) => parseInt(value, 10))
  const dataBlmValues = Object.values(blmData).map((value) => parseInt(value, 10))

  const formattedData = {
    labels: labelNamesa,
    datasets: [
      {
        label: 'Fantasy Points',
        backgroundColor: '#36A2EB',
        borderColor: '#36A2EB',
        pointBackgroundColor: '#36A2EB',
        pointBorderColor: '#36A2EB',
        data: dataValues,
      },
    ],
  }
  const formattedPriceChangeData = {
    labels: labelNamesa,
    datasets: [
      {
        label: 'Fantasy Value',
        backgroundColor: '#36A2EB',
        borderColor: '#36A2EB',
        pointBackgroundColor: '#36A2EB',
        pointBorderColor: '#36A2EB',
        data: dataPriceChangeValues,
      },
    ],
  }

  const formattedScData = {
    labels: ['1', '2', '3', '4', '5', '6', '7', '8+ '],
    datasets: [
      {
        label: 'Score Per match',
        backgroundColor: '#36A2EB',
        data: dataScValues,
      },
    ],
  }

  const formattedHwData = {
    labels: ['1', '2', '3', '4', '5', '6', '7', '8+ '],
    datasets: [
      {
        label: 'Home Win Per Match',
        backgroundColor: '#4BC0C0',
        data: dataHwValues,
      },
    ],
  }

  const formattedAwsData = {
    labels: ['1', '2', '3', '4', '5', '6', '7', '8+ '],
    datasets: [
      {
        label: 'Away Win Per Match',
        backgroundColor: '#36A2EB',
        data: dataAwValues,
      },
    ],
  }

  const formattedAlData = {
    labels: ['1', '2', '3', '4', '5', '6', '7', '8+ '],
    datasets: [
      {
        label: 'Away Loss Per Match',
        backgroundColor: '#4BC0C0',
        data: dataAlValues,
      },
    ],
  }

  const formattedHlData = {
    labels: ['1', '2', '3', '4', '5', '6', '7', '8+ '],
    datasets: [
      {
        label: 'Home Loss Per Match',
        backgroundColor: '#4BC0C0',
        data: dataHlValues,
      },
    ],
  }
  const formattedSswData = {
    labels: ['1', '2', '3', '4', '5', '6', '7', '8+ '],
    datasets: [
      {
        label: 'Single Score Win Per Match',
        backgroundColor: '#4BC0C0',
        data: dataSswValues,
      },
    ],
  }
  const formattedSslsData = {
    labels: ['1', '2', '3', '4', '5', '6', '7', '8+ '],
    datasets: [
      {
        label: 'Single Score Loss Per Match',
        backgroundColor: '#4BC0C0',
        data: dataSslsValues,
      },
    ],
  }
  const formattedOwtData = {
    labels: ['1', '2', '3', '4', '5', '6', '7', '8+ '],
    datasets: [
      {
        label: 'Only Winner in Team Per Match',
        backgroundColor: '#4BC0C0',
        data: dataOwtValues,
      },
    ],
  }
  const formattedBwmData = {
    labels: ['1', '2', '3', '4', '5', '6', '7', '8+ '],
    datasets: [
      {
        label: 'Biggest Win Margin Per Match',
        backgroundColor: '#4BC0C0',
        data: dataBwmValues,
      },
    ],
  }
  const formattedBlmData = {
    labels: ['1', '2', '3', '4', '5', '6', '7', '8+ '],
    datasets: [
      {
        label: 'Biggest Loss Margin Per Match',
        backgroundColor: '#4BC0C0',
        data: dataBlmValues,
      },
    ],
  }

  return loading ? (
    <Loader />
  ) : (
    <>
      <CRow>
        <CCol xs={12} sm={12} lg={12}>
          <CCard className="mb-4">
            <CCardHeader>Select Player</CCardHeader>
            <CCardBody>
              <CRow>
                <CCol md={6}>
                  <CFormSelect
                    aria-label="Select player"
                    name="player"
                    className={'form-control'}
                    onChange={handleSearchPlayer}
                    id="player"
                  >
                    <option value={0}>Select Player</option>
                    {playerList &&
                      playerList.map((item, key) => (
                        <option value={item?.id} key={key}>
                          {item?.full_name}
                        </option>
                      ))}
                  </CFormSelect>
                </CCol>
                <CCol md={6}>&nbsp;</CCol>
              </CRow>
            </CCardBody>
          </CCard>
        </CCol>
      </CRow>
      <CRow>
        <CCol md={6} sm={12}>
          <CCard className="mb-4">
            <CCardHeader>By Fantasy Points</CCardHeader>
            <CCardBody>
              <CCardBody>
                <CChartLine data={formattedData} />
              </CCardBody>
            </CCardBody>
          </CCard>
        </CCol>
        <CCol md={6} sm={12}>
          <CCard className="mb-4">
            <CCardHeader>By Fantasy Value</CCardHeader>
            <CCardBody>
              <CCardBody>
                <CChartLine data={formattedPriceChangeData} />
              </CCardBody>
            </CCardBody>
          </CCard>
        </CCol>

        <CCol md={6} sm={12}>
          <CCard className="mb-4">
            <CCardHeader>By Score</CCardHeader>
            <CCardBody>
              <CCardBody>
                <CChartLine data={formattedScData} />
              </CCardBody>
            </CCardBody>
          </CCard>
        </CCol>

        <CCol md={6} sm={12}>
          <CCard className="mb-4">
            <CCardHeader>By Home Win</CCardHeader>
            <CCardBody>
              <CCardBody>
                <CChartLine data={formattedHwData} />
              </CCardBody>
            </CCardBody>
          </CCard>
        </CCol>

        <CCol md={6} sm={12}>
          <CCard className="mb-4">
            <CCardHeader>By Away Win</CCardHeader>
            <CCardBody>
              <CCardBody>
                <CChartLine data={formattedAwsData} />
              </CCardBody>
            </CCardBody>
          </CCard>
        </CCol>

        <CCol md={6} sm={12}>
          <CCard className="mb-4">
            <CCardHeader>By Away Loss</CCardHeader>
            <CCardBody>
              <CCardBody>
                <CChartLine data={formattedAlData} />
              </CCardBody>
            </CCardBody>
          </CCard>
        </CCol>

        <CCol md={6} sm={12}>
          <CCard className="mb-4">
            <CCardHeader>By Home Loss</CCardHeader>
            <CCardBody>
              <CCardBody>
                <CChartLine data={formattedHlData} />
              </CCardBody>
            </CCardBody>
          </CCard>
        </CCol>

        <CCol md={6} sm={12}>
          <CCard className="mb-4">
            <CCardHeader>By Single Score Win </CCardHeader>
            <CCardBody>
              <CCardBody>
                <CChartLine data={formattedSswData} />
              </CCardBody>
            </CCardBody>
          </CCard>
        </CCol>
        <CCol md={6} sm={12}>
          <CCard className="mb-4">
            <CCardHeader>By Single Score Loss</CCardHeader>
            <CCardBody>
              <CCardBody>
                <CChartLine data={formattedSslsData} />
              </CCardBody>
            </CCardBody>
          </CCard>
        </CCol>
        <CCol md={6} sm={12}>
          <CCard className="mb-4">
            <CCardHeader>By Only Winner in Team</CCardHeader>
            <CCardBody>
              <CCardBody>
                <CChartLine data={formattedOwtData} />
              </CCardBody>
            </CCardBody>
          </CCard>
        </CCol>
        <CCol md={6} sm={12}>
          <CCard className="mb-4">
            <CCardHeader>By Biggest Win Margin</CCardHeader>
            <CCardBody>
              <CCardBody>
                <CChartLine data={formattedBwmData} />
              </CCardBody>
            </CCardBody>
          </CCard>
        </CCol>
        <CCol md={6} sm={12}>
          <CCard className="mb-4">
            <CCardHeader>By Biggest Loss Margin</CCardHeader>
            <CCardBody>
              <CCardBody>
                <CChartLine data={formattedBlmData} />
              </CCardBody>
            </CCardBody>
          </CCard>
        </CCol>
      </CRow>
    </>
  )
}

export default PlayerChart
